import React, { useEffect, useState } from "react";
import { api, formatGBP } from "@/lib/api";
import { Link } from "react-router-dom";
import { Scale, ArrowRight } from "lucide-react";

export default function SkipComparison() {
  const [skips, setSkips] = useState([]);

  useEffect(() => {
    api.get("/pricing/skip-sizes").then((r) => setSkips(r.data));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="text-xs uppercase tracking-[0.2em] text-gray-500">Skip vs Weigh Away</div>
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter text-white">
        The honest <span className="text-[#8DC63F]">price comparison.</span>
      </h1>
      <p className="text-gray-400 mt-3 max-w-2xl">
        Local skip prices are estimates and vary by postcode. With Weigh Away you only pay for what we
        actually take — no skip permits, no weight caps, no empty space charges.
      </p>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mt-10" data-testid="skip-grid">
        {skips.map((s) => (
          <div key={s.id} className="wa-card" data-testid={`skip-card-${s.id}`}>
            <div className="flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-gray-500">
              <Scale size={14} /> {s.weight_min_kg}–{s.weight_max_kg} kg
            </div>
            <div className="font-display text-2xl font-black mt-1 text-white">{s.name}</div>
            <div className="text-3xl font-display font-black mt-3 text-white">
              {formatGBP(s.price_low)}–{formatGBP(s.price_high)}
            </div>
            <div className="text-xs text-gray-500 mt-1">Typical local skip price</div>
            {s.notes && <div className="text-xs text-gray-400 mt-2">{s.notes}</div>}
            <div className="mt-4 border-t border-dashed border-[#232428] pt-3">
              <div className="text-xs text-[#8DC63F] font-semibold">With Weigh Away</div>
              <div className="text-sm text-gray-300">Pay only for the weight you actually have.</div>
            </div>
            <Link to="/book" className="wa-btn-primary mt-4 w-full justify-center" data-testid={`skip-cta-${s.id}`}>
              Get a Weigh Away quote <ArrowRight size={16} />
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
